import styled from 'styled-components';

const Container = styled.div`
  min-height: 3.325rem;
  background-color: ${({ theme }) => theme.palette.secondary.main};
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0.5rem 4.16667vw;
  justify-content: center;
  flex-wrap: wrap;

  @media screen and (min-width: 54.0625em) {
    justify-content: space-between;
  }
`;

export default Container;
